import { IDetection } from '../../../uanc.types';
import { AD_SERVERS, DSA_CONFIG, DSA_SLOT_MIN_WIDTH, DSA_SLOT_PADDING_DEL } from '../../../configs/constants';
import { IDFPServiceSlot, IRenderedPlacementDFP } from './service-dfp.types';
import { IAOServiceSlot } from '../ADOCEAN/service-adocean.types';
import { getWindowContext } from '../../../core/pre-config/pre-config.utils';

const createStyle = (placementId: string): void => {
    const document = getWindowContext().document;
    const style: HTMLStyleElement = document.createElement('style');
    style.innerHTML = `#dsa_${placementId}:hover > span { 
                visibility: visible!important;
            }
            #dsa_${placementId}:active > span { 
                visibility: visible!important;
            }
            
            `;
    style.id = `uanc_style_${placementId}`;
    document.getElementsByTagName('head')[0].appendChild(style);
};

const observeIframe = (slotDiv: HTMLElement, iframe: HTMLElement, el: HTMLSpanElement, placementPath: string): void => {
    const resizeObsr = new ResizeObserver((entries, observer) => {
        for (const entry of entries) {
            if (entry.contentBoxSize) {
                const contentBoxSize = entry.contentBoxSize[0];
                if (contentBoxSize.inlineSize > 10) {
                    el.style.left = '50%';
                    el.style.transform = `translate(-${contentBoxSize.inlineSize / 2}px, 0)`;
                    slotDiv.style.position = 'relative';

                    if (DSA_SLOT_MIN_WIDTH.find((item: string) => placementPath.startsWith(item))) {
                        if (contentBoxSize.inlineSize / 2 < 140) {
                            el.style.transform = 'translate(-140px, 0)';
                        }
                    }
                    observer.disconnect();
                }
            }
        }
    });

    resizeObsr.observe(iframe);
};

const createLabelDSA = (
    slotName: string,
    placementId: string,
    slotDiv: HTMLElement,
    iframe: HTMLElement,
    placementConfig: IRenderedPlacementDFP
): void => {
    const document = getWindowContext().document;
    const detection: IDetection = window.Inpl.Ad.detection as IDetection;

    const el: HTMLSpanElement = document.createElement('span');
    const elTooltip: HTMLSpanElement = document.createElement('span');
    const svg: HTMLSpanElement = document.createElement('span');
    const txt: HTMLSpanElement = document.createElement('span');

    if (slotName !== 'scroll_footer') {
        observeIframe(slotDiv, iframe, el, placementConfig.path);
    }

    svg.style.backgroundImage = `url("${detection.protocol}//${detection.libraryPath}images/info.svg")`;
    svg.style.width = '12px';
    svg.style.height = '12px';

    txt.innerHTML =
        '<a data-google-interstitial="false" style="cursor: context-menu; text-decoration: none; font-size: 10px; color: rgb(53, 48, 57)" href="#" onclick="return false">Treść zewnętrzna</a>';

    el.id = `dsa_${placementId}`;
    el.style.display = 'inline-flex';
    el.style.padding = '3px 5px';
    el.style.alignItems = 'center';
    el.style.gap = '5px';
    el.style.backgroundColor = '#F1F3F8';
    el.style.borderRadius = '3px 3px 0 0';
    el.style.position = 'absolute';
    el.style.left = '0';
    el.style.top = '0px';
    el.style.width = 'auto';
    el.style.minWidth = '100px';

    el.style.fontSize = '10px';
    el.style.lineHeight = 'normal';
    el.style.fontWeight = '400';

    el.style.cursor = 'context-menu';
    el.style.left = '50%';
    el.style.transform = 'translate(-50px, 0)';
    el.style.whiteSpace = 'nowrap';

    const link = placementConfig.advertiserId !== null ? DSA_CONFIG[placementConfig.advertiserId] : '';
    elTooltip.innerHTML = `Reklama prezentowana w ramach interfejsu internetowego ${link}`;
    elTooltip.style.padding = '6px 10px';
    elTooltip.style.justifyContent = 'center';
    elTooltip.style.alignItems = 'center';
    elTooltip.style.visibility = 'hidden';
    elTooltip.style.position = 'absolute';
    elTooltip.style.zIndex = '1';
    elTooltip.style.width = '178px';
    elTooltip.style.padding = '10px';
    elTooltip.style.fontSize = '10px';
    elTooltip.style.top = '20px';
    elTooltip.style.left = '0';
    elTooltip.style.backgroundColor = '#F8F9FD';
    elTooltip.style.boxShadow = '0px 8px 16px 0px rgba(0, 0, 0, 0.12)';
    elTooltip.style.textAlign = 'left';
    elTooltip.style.whiteSpace = 'initial';
    elTooltip.style.color = 'rgb(53, 48, 57)';

    slotDiv.style.paddingTop = '20px';

    if (slotName === 'scroll_footer') {
        el.style.right = '0';
        el.style.left = 'unset';
        el.style.transform = 'unset';
        elTooltip.style.right = '90px';
        elTooltip.style.left = '-125px';
        slotDiv.style.paddingTop = '0';
        el.style.top = '-20px';
        slotDiv.style.position = 'relative';
        slotDiv.style.minWidth = '100%';
    }

    if (DSA_SLOT_PADDING_DEL.find((item) => placementConfig.path.startsWith(item))) {
        el.style.top = '-15px';
        slotDiv.style.paddingTop = '5px';
    }

    createStyle(placementId);

    el.appendChild(svg);
    el.appendChild(txt);
    el.appendChild(elTooltip);
    (slotDiv.parentElement as HTMLElement).style.position = 'relative';
    (slotDiv.parentElement as HTMLElement).classList.add('prebid-dsa');
    slotDiv.appendChild(el);
};

/**
 * Obsługa oznaczeń DSA dla slotów DFP.
 *
 * @param { Partial<IDFPServiceSlot> | Partial<IAOServiceSlot>} slot - slot
 * @param {string} placementId - nazwa placementu, którego zdarzenie dotyczy
 *
 * @returns {void}
 */
export const dsaGAM = (slot: Partial<IDFPServiceSlot> | Partial<IAOServiceSlot>, placementId: string) => {
    if (slot.name && slot.adServer === AD_SERVERS.DFP && placementId && slot.renderedPlacements?.[placementId]) {
        try {
            const placementConfig: IRenderedPlacementDFP = slot.renderedPlacements![placementId] as IRenderedPlacementDFP;
            const document = getWindowContext().document;
            document.querySelector(`#uanc_style_${placementId}`)?.remove();
            document.querySelector(`#dsa_${placementId}`)?.remove();

            if (placementConfig.advertiserId !== null && placementConfig.advertiserId in DSA_CONFIG) {
                const slotDiv: HTMLElement | null = document.querySelector(`#${placementId} > div[id^="google_ads_iframe_"]`);
                const iframe: HTMLElement | null = document.querySelector(`#${placementId} > div[id^="google_ads_iframe_"] > iframe`);

                if (slotDiv && iframe) {
                    createLabelDSA(slot.name, placementId, slotDiv, iframe, placementConfig);
                }
            }
        } catch (error) {
            console.log('[dsaGAM] error:', error);
        }
    }
};
